
import React, {useState} from 'react';
import SignUpText from './SignUpTextOnScreen';
import FillUserInfo from './FillUserInfo';
import QuestionList from './QuestionList';
import NormalBtn from './NormalBtn';
import * as SharedAcross from './Common/SharedAcross';
import UserForm from './UserForm';
import DecisionTree from './DecisionTree';
import HTMLView from './HTMLView';

function App(props) {

  var height = props.height;
  var width = props.width;
  var adminAction = props.adminAction;
  var updateUserInfo = props.updateUserInfo;
  var subdomainID = props.subdomainID;
  var sessionHistoryID = props.sessionHistoryID;
  var pos = props.pos;
  var setIntentStuff = props.setIntentStuff;
  var levels = props.levels;
  var display = props.display;
  var isSubmitting = props.isSubmitting;
  var addToExtraScreen = props.addToExtraScreen;
  var setHandTarget = props.setHandTarget;
  var handTarget = props.handTarget;
  var boldTarget = props.boldTarget;
  var isSubmittingWhat = props.isSubmittingWhat;
  var setIsSubmittingWhat = props.setIsSubmittingWhat;
  var setExtraScreenSet = props.setExtraScreenSet;

  const [pictures, setPictures] = useState([]);
  const [picturePreview, setPicturePreview] = useState([]);

  var extraPiece = props.extraPiece;
  var displayType;
  if (extraPiece.t === "tuple"){
    displayType = extraPiece.v[0].v;
  }else{
    return null;
  }

  if (displayType === "questionList"){
    var pageResponse = extraPiece.v[1].v;
    var haveAccess = pageResponse[1].v;
    var mobilePage = pageResponse[3];
    var left = extraPiece.v[4];
    var subdomainIDHere = extraPiece.v[2].v;
    var userSubdomainIDHere = extraPiece.v[3].v;

    var showAllExtra = true;
    var topRow = [];

    function updateUserInfo(userSubdomainID, tokenId){
      var levels1 = SharedAcross.convertLevels(levels.concat([pos]));
      adminAction("submitLocation", {action:"setUserSubdomainID", sessionHistoryID, userSubdomainID, levels:levels1}, setIntentStuff);
    }
// updateUserInfo(UserSubdomainID, tokenId)
    var clickLogIn = function(e){
      addToExtraScreen({v:"logIn", post:updateUserInfo, subdomainID:subdomainIDHere, userSubdomainID:userSubdomainIDHere});
    }

    function clickLogOut(e){
      updateUserInfo(-1, "");
    }
    
    if (haveAccess === 1){
      return <QuestionList isSubmittingWhat={isSubmittingWhat} setIsSubmittingWhat={setIsSubmittingWhat} left={left} cover={mobilePage} display={display} adminAction={adminAction} setIntentStuff={setIntentStuff} width={width} sessionHistoryID={sessionHistoryID} updateUserInfo={updateUserInfo} height={height} topRow={topRow} subdomainID={subdomainIDHere} isSubmitting={isSubmitting}  showAllExtra={showAllExtra} levels={levels.concat([pos])} firstLineTitle={""} isRight={true} handTarget={handTarget} setHandTarget={setHandTarget} userSubdomainID={userSubdomainIDHere} clickLogIn={clickLogIn} clickLogOut={clickLogOut} boldTarget={boldTarget} picturePreview={picturePreview} setPicturePreview={setPicturePreview} setPictures={setPictures} pictures={pictures} startPoint={0} endPoint={left.v[1].v.length - 1} setExtraScreenSet={setExtraScreenSet}/>
    }else if (userSubdomainIDHere === -1){
      return <NormalBtn onClick={clickLogIn} title="Log In"/>
    }else{
      return <center><br/>{haveAccess}<br/><NormalBtn onClick={clickLogOut} title="Log Out"/></center>
    }
    //
  }else if (displayType === "logIn"){
        return <center style={{padding:"10px"}}>
                      <div style={{fontSize:"1.5em"}}><b>To proceed, please log in</b></div>
                      <br/>
                      <SignUpText updateUserInfo={updateUserInfo} subdomainID={subdomainID} setExtraScreenSet={setExtraScreenSet}/>      
                      <br/><br/>
                    </center>
  //                  
    }else if (displayType === "userInfo"){

      function submitUserInfo(userName, postalCode, address, unitNos, phoneNos){
        adminAction("submitUserInfo", {userName, postalCode, address, unitNos, phoneNos, pos, sessionHistoryID}, setIntentStuff);
      }

      return <center style={{padding:"10px"}}>
              <FillUserInfo adminAction={adminAction} submitUserInfo={submitUserInfo} origInfo={extraPiece.v[1].v} />      
            </center>
//            
    }else if (displayType === "form"){

      function submitFormInfo(formInfo, programName, refNos){
        adminAction("submitFormInfo", {formInfo, programName, refNos, pos, sessionHistoryID}, setIntentStuff);
      }

      return <center style={{padding:"10px"}}>
              <UserForm adminAction={adminAction} submitFormInfo={submitFormInfo} origInfo={extraPiece} />      
            </center>
  //
    }else if (displayType === "dv"){
      return <HTMLView html={extraPiece} height={height} width={width} />
        //                  
    }else if (displayType === "empty"){
      return null;
    }else if (displayType === "back"){
      function clickTeleport(e){
        var levelsHere = extraPiece.v[1].v.map((aLevel, index) =>{
          return {v:aLevel.v};
        });
        adminAction("submitLocation", {action:"teleport", levels:levelsHere, sessionHistoryID}, setIntentStuff);
      }
      return <NormalBtn title="Complete the rest of this action (Paused here in edit mode)" onClick={clickTeleport} />
    }else if (displayType === "decisionTree"){
      return <DecisionTree tree={extraPiece.v[1]}/>

    }else{
      console.log(displayType);
    }      
    return null;
    //
}




export default App;
